import React from "react";
import { Link } from "../../../design/link";
import { ChevronRightIcon } from "@heroicons/react/20/solid";
const SettingsHeader: React.FC = () => {
  return (
    <div className="inline-flex items-center gap-2 text-sm/6">
      <Link href="/settings">Settings</Link>
      <ChevronRightIcon className="size-4 fill-zinc-400 dark:fill-zinc-500" />
    </div>
  );
};

export default SettingsHeader;
